import Vue from 'vue';
import Vuex from 'vuex';

import { getConfig } from '../api/config';
import { tokenLogin } from '../api/user';
import { logWarn, log } from '../utils/log';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    keepAliveTimer: null,
    config: {
      brandId: null,
      brandName: null,
      prismaUrl: null,
      crmUrl: null,
      fusionUrl: null,
      pusherKey: null,
      pusherRegion: null,
      enableJWT: false,
    },
    user: {
      userId: -1,
      authToken: null,
      jwtToken: null,
    },
    isMobile: false,
  },
  getters: {
    brandId: state => state.config.brandId,
    brandName: state => state.config.brandName,
    prismaUrl: state => state.config.prismaUrl,
    crmUrl: state => state.config.crmUrl,
    fusionUrl: state => state.config.fusionUrl,
    enableJWT: state => state.config.enableJWT,
    pusherKey: state => state.config.pusherKey,
    pusherRegion: state => state.config.pusherRegion,

    userId: state => state.user.userId,
    authToken: state => state.user.authToken,
    jwtToken: state => state.user.jwtToken,
    isMobile: state => state.isMobile,
  },
  actions: {
    reset({ commit }) {
      commit('RESET');
    },
    setConfig({ commit }, data) {
      commit('SET_BRAND_NAME', data);

      return new Promise((resolve, reject) => {
        getConfig(data.brandName).then((response) => {
          if (response && response.data) {
            const config = { ...response.data };
            config.enableJWT = data.enableJWT;
            commit('SET_CONFIG', config);
            return resolve();
          }
          return reject();
        }).catch(error => reject(error));
      });
    },
    initKeepAliveTimer({ getters, dispatch }, data) {
      if (this.state.keepAliveTimer) clearInterval(this.state.keepAliveTimer);

      this.state.keepAliveTimer = setInterval(() => {
        const payload = {
          sid: (window && window.sid) ? window.sid : '',
          enableJWT: getters.enableJWT,
          fusionUrl: getters.fusionUrl,
        };

        if (window.source) payload.source = window.source;

        dispatch('authenticate', payload).then(() => {
          log('Successfully re-authenticated (keep alive)');
        }).catch((error) => {
          logWarn('Failed to re-authenticate (keep alive)', error);
        });
      }, 1800000); // 1800000 ms = 30 minutes
    },
    authenticate({ commit, dispatch, getters }, data) {
      return new Promise((resolve, reject) => {
        tokenLogin(data.enableJWT, data.sid, getters.fusionUrl, data.source)
          .then((response) => {
            if (!response.data.Success) {
              const errArr = ['Could not authenticate'];
              if (response.data.Errors && response.data.Errors.length > 0) {
                response.data.Errors.forEach((error, index) => {
                  errArr.push(`Error ${index}: ${error.Message}`);
                });
              }
              return reject(errArr);
            }

            commit('SET_BRAND_ID', { brandId: response.data.Data.User.BrandId });
            commit('SET_USER', {
              userId: response.data.Data.User.UserId,
              authToken: response.data.Data.Authentication.AuthToken,
              jwtToken: data.enableJWT ? data.sid : response.data.Data.JwtToken,
            });

            dispatch('initKeepAliveTimer');

            return resolve();
          })
          .catch(error => reject(error));
      });
    },
    setMobileResponsive({ commit }, payload) {
      commit('SET_MOBILE_RESONSIVE', payload);
    },
  },
  mutations: {
    SET_CONFIG(state, data) {
      state.config.prismaUrl = data.prismaUrl;
      state.config.fusionUrl = data.fusionUrl;
      state.config.crmUrl = data.crmUrl;
      state.config.pusherKey = data.pusherKey;
      state.config.pusherRegion = data.pusherRegion;
      state.config.enableJWT = data.enableJWT;

      const baseUrl = (data.prismaUrl || '')
        .replace('/prisma-api/', '')
        .replace('/prisma-api', '')
        .replace('/api-exposer/', '')
        .replace('/api-exposer', '');
      if (!window.ftcrm) {
        window.ftcrm = {
          auth: undefined,
          baseApiUrl: baseUrl,
        };
      }
      window.ftcrm.baseApiUrl = baseUrl;
    },
    SET_BRAND_NAME(state, data) {
      state.config.brandName = data.brandName;
    },
    SET_BRAND_ID(state, data) {
      state.config.brandId = data.brandId;
    },
    SET_USER(state, data) {
      if (!window.ftcrm) {
        window.ftcrm = {
          auth: undefined,
        };
      }
      window.ftcrm.auth = {
        userId: data.userId,
        authToken: data.authToken,
        jwtToken: data.jwtToken,
      };

      state.user.userId = data.userId;
      state.user.authToken = data.authToken;
      state.user.jwtToken = data.jwtToken;
    },
    AUTHENTICATE(state, data) {
      state.prismaUrl = data;
    },
    RESET(state) {
      state.config.brandId = null;
      state.config.brandName = null;
      state.config.prismaUrl = '';
      state.config.crmUrl = '';
      state.config.fusionUrl = '';
      state.config.pusherKey = '';
      state.config.pusherRegion = '';
      state.config.enableJWT = false;

      state.user.userId = 0;
      state.user.authToken = '';
      state.user.jwtToken = '';

      window.ftcrm.auth = undefined;

      clearInterval(state.keepAliveTimer);
    },
    SET_MOBILE_RESONSIVE(state, payload) {
      state.isMobile = payload;
    },
  },
  modules: {
  },
});
